import { css } from '@emotion/react'
import styled from '@emotion/styled'

const categoryTitleStyles = ({ theme }) => css`
  label: faq-category__title;

  display: inline-flex;
  align-items: center;
  gap: ${theme.spacings.bit};
`

export const CategoryTitle = styled('span')(categoryTitleStyles)
